import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/roboto-mono-vietnamese-normal-6f1e6273.woff2%22,%22weight%22:%22100%20700%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22figure%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0102-0103,%20U+0110-0111,%20U+0128-0129,%20U+0168-0169,%20U+01A0-01A1,%20U+01AF-01B0,%20U+0300-0301,%20U+0303-0304,%20U+0308-0309,%20U+0323,%20U+0329,%20U+1EA0-1EF9,%20U+20AB%22}]}],%22variableName%22:%22figureVietnamese%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'figureVietnamese'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
